import styled from 'styled-components';

import { theme } from '_constants/theme';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { devices, fontSizes, colors, spaces } = theme;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledTrustCard = styled.div`
  height: 100%;
  justify-content: space-between;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  padding: ${spaces.large2X - 2}px ${spaces.medium}px ${spaces.medium}px
    ${spaces.large2X - 2}px;
  background: linear-gradient(
    180deg,
    ${colors.gray[100]} 0%,
    rgba(249, 250, 251, 0) 100%
  );
  border-radius: 30px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 1;
  width: 100%;
  @media ${devices.tablet} {
    padding: ${spaces.medium}px;
    .headerSection {
      padding: 0px ${spaces.regular}px;
      font-size: ${fontSizes.large2X}px;
      line-height: 150%;
    }
    .subHeaderSection {
      padding: 0px ${spaces.regular}px;
      font-size: ${fontSizes.regular}px;
      line-height: 150%;
      margin-top: ${spaces.smallX}px;
      margin-bottom: ${spaces.large2X}px;
    }
  }
`;
const StyledTrustDescription = styled.div`
  margin-top: ${spaces.medium}px;
  margin-bottom: ${spaces.medium}px;
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.large}px;
  line-height: 150%;
  color: ${colors.gray[800]};
  text-align: justify;
  align-self: stretch;
  @media ${devices.tablet} {
    font-size: ${fontSizes.regular}px;
    text-align: left;
  }
`;
const StyledTrustStarDescription = styled.div`
  text-align: left;
  @media ${devices.tablet} {
    text-align: center;
  }
`;
const StyledTrustAuthor = styled.div`
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.large}px;
  line-height: 150%;
  text-transform: uppercase;
  color: ${colors.gray[800]};
  @media ${devices.tablet} {
    text-align: center;
  }
`;
const StyledTrustCustomer = styled.div`
  font-family: 'Aeonik';
  font-style: normal;
  font-weight: 400;
  font-size: ${fontSizes.regular}px;
  line-height: 150%;
  color: ${colors.gray[500]};
  @media ${devices.tablet} {
    text-align: center;
  }
`;
const TrustCard = ({ description, author }) => {
  return (
    <StyledTrustCard>
      <div>
        <StyledTrustStarDescription>
          <picture>
            <source
              srcSet={`${publicRuntimeConfig.basePath}/images/5-star.svg`}
              type="image/png"
            />
            <img
              src={`${publicRuntimeConfig.basePath}/images/5-star.svg`}
              alt=""
            />
          </picture>
        </StyledTrustStarDescription>
        <StyledTrustDescription>{description}</StyledTrustDescription>
      </div>
      <div style={{ width: '100%' }}>
        <StyledTrustAuthor>{author}</StyledTrustAuthor>
        <StyledTrustCustomer>Trademark Genius Customer</StyledTrustCustomer>
      </div>
    </StyledTrustCard>
  );
};

export default TrustCard;
